export default __webpack_public_path__ + "static/media/default-category-thumbnail.bc87fa67.png";